import { productAPI } from '../api/product';
import { actionWrapper } from './actionWrapper';

export const SET_PRODUCTS = 'SET_PRODUCTS';
export const SET_BASKET_PRODUCTS = 'SET_BASKET_PRODUCTS';

export const getProducts = () => actionWrapper(async () => {
  const productsData = await productAPI.getProducts();
  return {
    type: SET_PRODUCTS,
    payload: productsData,
  };
});

export const getBasketProducts = (shop) => actionWrapper(async () => {
  const productsData = await productAPI.getBasketProducts();
  console.log('===shop', shop);

  return {
    type: SET_BASKET_PRODUCTS,
    payload: productsData,
  };
});